/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_SavingsInputs */

const es_admin_billing_batch_savings = /** @type {(inputs: Admin_Billing_Batch_SavingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorro`)
};

const en_admin_billing_batch_savings = /** @type {(inputs: Admin_Billing_Batch_SavingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Savings`)
};

/**
* | output |
* | --- |
* | "Savings" |
*
* @param {Admin_Billing_Batch_SavingsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_savings = /** @type {((inputs?: Admin_Billing_Batch_SavingsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_SavingsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_savings(inputs)
	return en_admin_billing_batch_savings(inputs)
});
export { admin_billing_batch_savings as "admin.billing.batch.savings" }